export default "__VITE_PUBLIC_ASSET__c9f0763d__"